<template>
  <div
    class="f-column flex-1"
    style="gap: 0.5rem"
  >
    <ExpandCard
      :closed="false"
      :canClose="false"
      :icon="'mdi-target'"
      :title="$t('common.drills')"
      style="
        margin: 0 0 auto 0;
        --max-height: var(--max-height-info);
        --content-padding: 0.75rem;
        --radius: 4px;
        --tooltip-margin: -2rem 0 0 -1rem;
        --tooltip-transform: translate(-100%, 0);
        --icon-opener-margin: 0 0 0 0;
      "
    >
      <div class="trainer-presets trapresets">
        <div
          style="position: sticky; top: -1px; z-index: 4"
          class="drag-noevents"
        >
          <UnSwitcherNew
            class=""
            :hasText="true"
            :asMenu="false"
            translatePath="common"
            :tab="drillType"
            :options="[{ payload: 'my_drills' }, { payload: 'public_drills' }]"
            style="--gwbtn-flex: 1; margin: 0 0 0.5rem 0"
            @click="item => (drillType = item.payload)"
          />
        </div>
        <v-progress-circular
          v-if="apiCall.loading"
          class="mt-4 mx-auto"
          :model-value="90"
          :size="50"
          :indeterminate="true"
        ></v-progress-circular>
        <div
          v-else-if="!drills.length"
          class="trapresets_info"
        >
          <div
            class="mx-auto"
            v-html="$t('messages.no_drills')"
          ></div>
          <router-link
            :to="{ name: linkDrills.pathName, query: linkDrills.query || {} }"
            class="link-underline cursor-pointer mx-auto clr-primary"
            v-html="$t('messages.manage_drills_here')"
          ></router-link>
        </div>
        <div
          v-else-if="drillType === 'my_drills'"
          style="z-index: 1"
          class="trapresets_items"
        >
          <div
            v-for="(item, index) in drills"
            :id="`drills_preset_item_${index}`"
            :key="item.id"
          >
            <TrainerPresetItem
              class="drag-noevents"
              :selectedPreset="l_selectedDrill"
              :active="item.active"
              :hasIcons="hasIcons"
              :namespace="namespace"
              :item="item"
              :hasDragdrop="true"
              :isDragged="draggedItem ? draggedItem.id === item.id : false"
              :data-tst="`drill_custom_${item.name}`"
              @drag:start="e => handleDragstart({ e, item })"
              @click="handleClick(item)"
              @configure="({ dialogProp }) => openAdvancedFilter({ item, dialogProp })"
              @startGame="startGame(item)"
            />
          </div>
        </div>
        <div
          v-else
          style="z-index: 1"
        >
          <ExpandCard
            v-for="block in gwizDrills"
            :key="block.id"
            :title="block.name"
            style="
              --content-padding: 1px 0 1px 0;
              --icon-opener-margin: 0 0.5rem 0 0;
              --title-padding: 0 0.5rem 0 0.5rem;
              --title-direction: row-reverse;
              --title-justify-content: flex-start;
              --title-padding: 0;
              --clr-back-title: var(--clr-black-1);
              --clr-back-title-hover: var(--clr-black-1);
              --clr-back-title-active: var(--clr-black-1);
              --title-justify-content: flex-end;
            "
            :opened="openedBlocks.includes(block.id)"
            :openerProps="{
              icon: 'mdi-chevron-right',
              rotatedClass: 'rotated_90_before',
              tooltipStyle: 'right: -0.25rem; transform: translate(100%, 0)',
            }"
            @update:open="bool => toggleBlock(bool, block.id)"
          >
            <div
              v-if="block.id === 'cash'"
              class="d-flex"
            >
              <UnSwitcherNew
                class=""
                :hasText="true"
                :asMenu="false"
                translatePath="gametypes"
                :tab="cash500 ? 'Cash6m500zSimple' : 'Cash6m50zSimple'"
                :options="[{ payload: 'Cash6m50zSimple' }, { payload: 'Cash6m500zSimple' }]"
                style="--gwbtn-flex: 1; margin: 0 0 0.5rem 0; --uns-btn-padding: 0 0.5rem"
                @click="item => (cash500 = item.payload === 'Cash6m500zSimple')"
              />
            </div>

            <div class="trapresets_items">
              <TrainerPresetItem
                v-for="item in block.id === 'cash' ? getGwizCash(block.drills) : block.drills"
                :key="item.id"
                :selectedPreset="l_selectedDrill"
                :active="item.active"
                :hasIcons="hasIcons"
                :namespace="namespace"
                :item="item"
                :data-tst="`drill_gwiz_${item.name}`"
                @click="handleClick(item)"
                @configure="({ dialogProp }) => openAdvancedFilter({ item, dialogProp })"
                @startGame="startGame(item)"
              />
            </div>
          </ExpandCard>
        </div>

        <DragDropHandler
          ref="dragdrophandler"
          dropTargetIdPart="drills_preset_item"
          @drag:drop="handleDragdrop"
        >
          <template #shallowitem>
            <div
              class="gw_box"
              style="--clr-box-back: var(--clr-primary)"
            >
              <div class="truncate">
                {{ draggedItem ? draggedItem.name : '' }}
              </div>
            </div>
          </template>
        </DragDropHandler>
      </div>
    </ExpandCard>
    <div
      class="f-center pa-2 mt-auto drag-noevents"
      style="gap: 0.5rem; position: sticky; bottom: 0; background: var(--clr-black-0-3); z-index: 4"
    >
      <NavCard
        :item="{
          title: $t('common.new_drill'),
          icon: 'mdi-plus-circle',
        }"
        :hasIcon="false"
        :hasTitleIcon="true"
        :hasSub="false"
        :hasTag="false"
        class="flex-1 navcard_centered navcard_reversed_l navcard_small text-nowrap"
        style="
          --padding: 0.5rem 0.5rem;
          --clr-back: transparent;
          --icon-inset: 0.075rem auto auto -0.175rem;
        "
        @click="openAdvancedFilterNewDrill"
      />
      <router-link :to="{ name: linkDrills.pathName, query: linkDrills.query || {} }">
        <NavCard
          :item="{ title: $t('common.manage_drills'), icon: linkDrills.icon }"
          :hasIcon="false"
          :hasTitleIcon="true"
          :hasSub="false"
          :hasTag="false"
          class="flex-1 navcard_centered navcard_reversed_l navcard_small text-nowrap"
          style="
            --padding: 0.5rem 0.5rem;
            --clr-back: transparent;
            --icon-inset: 0.075rem auto auto -0.175rem;
          "
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import TrainerPresetItem from '@/components/Trainer/TrainerPresets/TrainerPresetItem'
import DragDropHandler from '@/components/lib/DragDropHandler'
import { findDrill } from '@/helpers/trainer_presets'
import { getGametypeOrder } from '@/helpers/constants'
import { getGameformatGroup } from '@/store/gameformat/gameformat'

import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerPresets',
  components: {
    TrainerPresetItem,
    DragDropHandler,
    ExpandCard,
    UnSwitcherNew,
  },
  mixins: [links_mix],
  props: {
    namespace: { String, required: true },
    hasTabs: Boolean,
    hasIcons: { type: Boolean, default: true },
  },
  emits: ['start'],
  data() {
    return {
      openedBlocks: [],
      drillType: 'my_drills',
      presetsCategories: [],
      cash500: null,
      group: 'cash',
      activatedItem: null,
      draggedItem: null,
    }
  },
  methods: {
    toggleBlock(bool, id) {
      let res = this.openedBlocks
      if (!bool) {
        res = res.filter(c => c !== id)
      } else {
        res = [...res, id]
      }
      this.openedBlocks = res
    },
    handleDragstart({ e, item }) {
      this.draggedItem = item
      // debugger
      if (this.$refs.dragdrophandler) {
        this.$refs.dragdrophandler.startDrag(e)
      }
    },
    handleDragdrop({ e, dropTarget, dropSurface }) {
      if (dropTarget && dropSurface) {
        const dropIdx = Number(dropTarget.id.replace('drills_preset_item_', ''))
        const { drills } = this
        const dropItem = drills[dropIdx]
        const args = {
          dropItem,
          dropSurface,
          draggedRows: [this.draggedItem],
          drills,
          sortOrder: 'asc',
        }
        // console.log(args)
        this.$store.dispatch('drills_handle_drop', args)
      }
      this.draggedItem = null
    },
    getGwizCash(drills) {
      const res = drills.filter(d =>
        this.cash500 ? d.query.gametype?.includes('500') : !d.query.gametype?.includes('500'),
      )
      // console.log(res)
      return res
    },
    openImportDrillDialog() {
      const dialog = `import-drill-dialog_namespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    handleClick(item) {
      if (item.active) return
      this.$store.dispatch('globals_action', 'trainer_drill_changed')

      setTimeout(() => {
        this.setSelectedPreset(item)
        this.$store.dispatch(`${this.namespace}/gamestate_reset_history`, {
          namespace: this.namespace,
        })
        this.$store.dispatch(`${this.namespace}/router_update_query`, {
          query: item.query,
          push: false,
        })

        // TODO 'router-to-gmf-selektor' review
        this.$store.dispatch('poker_copy_module', {
          from_namespace: this.namespace,
          to_namespace: this.namespace,
          queryGroup: 'router-to-gmf-selektor',
        })

        if (item?.query?.fh_start_spot === 'custom_spot') {
          if (item?.query?.solution_type === 'custom') {
            return
          }
          this.$store.dispatch('api_poker_history', { namespace: this.namespace })
        } else {
          this.$store.commit(`${this.namespace}/gamestate_set`, {
            key: 'history_spots',
            value: [],
          })
        }
      })
    },
    setSelectedPreset(item) {
      const res = {
        ...item,
        name: item?.name || this.$t('common.new_drill'),
      }
      // console.log(res)
      this.$store.commit('drills_set', { key: 'drills_selected_drill', value: res })
    },
    openAdvancedFilterNewDrill() {
      this.$store.commit(`drills_reset`) // newDrill
      const dialog = `trainer-advanced-filter-dialog_namespace-${this.namespace}_tmpNamespace-${this.namespace}_newdrill`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    openAdvancedFilter({ item, dialogProp }) {
      if (item) {
        this.handleClick(item)
      }
      this.setSelectedPreset(item)

      const tmpNamespace = 'tmp/primary'
      const apiAction = 'play'
      // const apiAction = item.public ? 'newdrill-play' : 'editdrill-play'
      const dialog = `trainer-advanced-filter-dialog_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}_${apiAction}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    startGame(item) {
      this.handleClick(item)
      this.setSelectedPreset(item)
      this.$emit('start')
    },
    switchType() {
      this.setSelectedPreset(this.l_selectedDrill)
      if (!this.drills.length) {
        this.drillType = 'public_drills'
      }
      if (this.l_selectedDrill?.public) {
        this.drillType = 'public_drills'
      }
      this.cash500 = this.l_selectedDrill?.query?.gametype?.includes('500')
      // debugger
      this.openBlock()
    },
    openBlock() {
      if (this.drillType === 'public_drills') {
        const gameformat =
          this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gameformat`]
        const item = this.gwizDrills.find(i => i.id === gameformat.group)
        if (item) {
          this.openedBlocks = [item.id]
        }
      }
    },
  },
  computed: {
    linkDrills() {
      return this.links_getItem({ options: this.links_practice_all, pathName: 'PracticeDrills' })
    },
    apiDrills() {
      return this.$store.getters.drills_all
    },
    allDrills() {
      let res = this.apiDrills
      const { drill } = findDrill({ query: this.queryTrainer, drills: res })
      res = res.map(d => {
        const active = drill?.id === d.id
        const r = {
          ...d,
          active,
          l_gmf_format: (
            (d.query.gametype && getGameformatGroup(d.query.gametype)) ||
            ''
          ).toLowerCase(),
        }
        return r
      })
      return res
    },
    drills() {
      if (this.apiCall.loading) {
        return []
      }
      let res = this.allDrills

      if (this.drillType === 'my_drills') {
        res = res.filter(i => !i.public)
      } else {
        res = res.filter(i => i.public)
      }
      // res = res.filter(i => i.favorite)

      res.sort((a, b) => (a.ordering_position < b.ordering_position ? -1 : 1))
      // console.log(res)
      return res
    },
    gwizDrills() {
      let groups = this.drills.reduce((a, b) => [...a, b.l_gmf_format], [])
      groups = [...new Set(groups)]
      const order = getGametypeOrder()
      groups = groups.sort((a, b) => (order.indexOf(a) < order.indexOf(b) ? -1 : 1))

      const res = groups.map(g => {
        const drills = this.drills.filter(i => i.l_gmf_format === g)
        const active = drills.some(d => d.active)
        const r = {
          id: g,
          name: this.$t(`gametypes.groups.${g}`),
          drills,
          active,
        }
        return r
      })
      return res
    },
    apiCall() {
      return this.$store.getters.api_get('api_poker_drills')
    },
    customPresets() {
      return this.$store.getters.drills_all
    },
    l_selectedDrill() {
      const activeDrills = this.allDrills.filter(i => i.active)
      const myDrills = activeDrills.filter(i => !i.public)
      const res = myDrills?.[0] || activeDrills?.[0]
      // console.log(res)
      return res
    },
    queryTrainer() {
      return this.$store.getters[`${this.namespace}/query_trainer`]
    },
  },
  watch: {
    l_selectedDrill: {
      immediate: false,
      handler: 'switchType',
    },
    drillType: {
      immediate: true,
      handler: 'openBlock',
    },
  },
}
</script>
<style lang="scss" scoped>
.trapresets {
  display: flex;
  flex-direction: column;
  &_items {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  &_tab-view {
    &_items {
      padding: 0.5rem 0 0 0;
      height: 32rem;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  &_gametype {
    &_title {
      padding: 1rem 1rem 0.5rem 0.75rem;
      font-size: 0.8rem;
      font-weight: 500;
      // font-weight: 700;
      color: var(--clr-grey-2);
    }
  }
  &_custom-presets {
    padding: 0.5rem 0.75rem;
  }
  &_info {
    color: var(--clr-grey-2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    &_icon {
      color: var(--clr-grey-2);
      font-size: 1.75rem;
    }
  }
}
.rake-tabs {
  background: var(--clr-black-2);
  display: flex;
  align-self: flex-start;
  border-radius: 4px;
  margin: 1rem 0 0 0.75rem;
  flex-grow: 0;
  &_tab {
    font-size: 0.8rem;
    line-height: 1;
    text-transform: uppercase;
    padding-bottom: 2px;
    transition: 0.2s;
    color: var(--clr-grey-2);
  }
}
</style>
